// src/theme/theme.ts
import { createTheme, Shadows } from '@mui/material/styles';

// Tokens
import { colors } from './tokens.colors';
import { spacingPx } from './tokens.spacing';
import { radius } from './tokens.radius';
import { shadows as uikitShadows } from './tokens.shadows';
import { typography as typeTokens } from './tokens.typography';

// Helper para generar el array de sombras que exige MUI (25 niveles)
const muiShadows: Shadows = [
  'none', // 0
  uikitShadows.xs, // 1
  uikitShadows.small, // 2
  uikitShadows.medium, // 3
  uikitShadows.large, // 4
  uikitShadows.xlarge, // 5
  ...Array(19).fill('none'), // 6–24 (no usados)
] as Shadows;

// =====================================================================================
// THEME PRINCIPAL
// =====================================================================================
const theme = createTheme({
  // ------------------------------------
  // 🎨 PALETTE
  // ------------------------------------
  palette: {
    primary: {
      main: colors.primary[400],
      dark: colors.primary[700],
      light: colors.primary[100],
    },
    secondary: {
      main: colors.secondary[500],
      dark: colors.secondary[700],
      light: colors.secondary[100],
    },
    error: {
      main: colors.error[500],
      dark: colors.error[700],
      light: colors.error[50],
    },
    warning: {
      main: colors.warning[500],
      dark: colors.warning[700],
      light: colors.warning[100],
    },
    success: {
      main: colors.success[500],
      dark: colors.success[700],
      light: colors.success[100],
    },
    // Estos tres requieren la augmentation que ya comentamos
    // tertiary: {
    //   main: colors.tertiary[600],
    //   light: colors.tertiary[100],
    //   dark: colors.tertiary[800],
    // },
    // neutral: {
    //   main: colors.neutral[500],
    //   light: colors.neutral[50],
    //   dark: colors.neutral[700],
    // },
    // neutralVariant: {
    //   main: colors.neutralVariant[500],
    //   light: colors.neutralVariant[50],
    //   dark: colors.neutralVariant[800],
    // },
    text: {
      primary: colors.neutral[900],
      secondary: colors.neutral[700],
    },
    background: {
      default: colors.neutralVariant[50],
      paper: '#ffffff',
    },
  },
  // ------------------------------------
  // 🅰️ TYPOGRAPHY
  // ------------------------------------
  typography: {
    fontFamily: typeTokens.fontFamily,

    h1: typeTokens.h1.regular,
    h2: typeTokens.h2.regular,
    h3: typeTokens.h3.regular,
    h4: typeTokens.h4.regular,
    h5: typeTokens.h5.regular,
    h6: typeTokens.h6.regular,

    subtitle1: typeTokens.subtitle1.regular,
    subtitle2: typeTokens.subtitle2.regular,

    body1: typeTokens.body1.regular,
    body2: typeTokens.body2.regular,

    caption: typeTokens.caption.regular,

    button: {
      ...typeTokens.button.regular,
      textTransform: 'none',
    },

    overline: typeTokens.overline.regular,
  },

  // ------------------------------------
  // 📏 SPACING
  // Base 8px, igual que el UI Kit
  // ------------------------------------
  spacing: spacingPx[8],

  // ------------------------------------
  // 🧊 SHAPE / RADIUS
  // ------------------------------------
  shape: {
    borderRadius: radius.m, // 8px — valor base
  },

  // ------------------------------------
  // 🌫 SHADOWS
  // ------------------------------------
  shadows: muiShadows,

  // ------------------------------------
  // 🎛 COMPONENT OVERRIDES (inicial)
  // API v5: `components.<Component>.styleOverrides` (reemplaza el
  // `overrides: { <Component>: {...} }` de v4).
  // ------------------------------------
  components: {
    MuiPaper: {
      styleOverrides: {
        elevation1: { boxShadow: uikitShadows.small },
        elevation3: { boxShadow: uikitShadows.medium },
        elevation5: { boxShadow: uikitShadows.large },
      },
    },
  },
});

export default theme;
